<template>
    <b-card>
     <div>
        <div class="table-render-skeleton" v-show="loading.first">
          <b-skeleton-table :columns="schema.length || 10" :table-props="{}" />
        </div>
        <div v-show="!loading.first" class="table-enviaflex">
          <table-render 
          :schema="schema" 
          :rows="rows" 
          :loading="loading.account" 
          :actions="actions"
          >
            <template #is_active="scope">
              <i class="fa fa-circle text-success" :class="{'text-danger': !scope.rowdata.is_active}"></i>
              <span>&nbsp;{{scope.rowdata.is_active ? 'Activa' : 'Inactiva'}}</span>
            </template>
          </table-render>
          <pagination
            v-if="!loading.first"
            :pagination="pagination"
            :noDigits="false"
            :showSize="true"
            :disabled="loading.account"
          />
        </div>
      </div>
      <modal-Meliflex-account
        id="modalEditMeliFlex"
        :accountID="selectedId"
        :loadingEdit="loadingEdit"
        @refreshID="refreshID"
        @refreshAccounts="getAccountData"
      />
      
    </b-card>
</template>
<script>
import { mapGetters } from 'vuex'
import ModalMeliflexAccount from './ModalMeliflexAccount.vue'

export default {
  components: { ModalMeliflexAccount },
  props: ['loadingEdit'],
  data() {
    return {
      pagination: { page: 1, limit: 10, total: 0 },
      rows: [],
      schema: [],
      actions: [],
      loading: {
        first: true,
        account: false
      },
      selectedId: null
    }
  },
  mounted() {
    this.setInitialData()
  },
  computed: {
    ...mapGetters({
      accounts: 'getAccountsFlex'
    })
  },
  watch: {
    'pagination.page'() {
      this.getAccountData()
    },
    'pagination.limit'() {
      if (this.pagination.page === 1) this.getAccountData()
    },
    accounts(value) {
      this.rows = value?.data
      this.pagination.page = value?.pagination?.current_page
      this.pagination.total = value?.pagination?.total_pages
      this['pagination.limit'] = value?.pagination?.rows_per_page

      this.loading.first = false
      if (this.rows?.length > 0) {
        this.schema.push({ label: 'Acciones', key: 'actions', class: ['text-center'] })
      }

    }
  },
  methods: {
    setInitialData() {
      this.schema = [
        { label: 'Nombre', key: 'name', doubleDash: true },
        { label: 'Código', key: 'code' },
        { label: 'Fecha creación', key: 'created_at', doubleDash: true },
        { label: 'Estado cuenta', key: 'is_active', useSlot: true }
      ]

      this.actions = [
        { action: id => this.openModalEdit(id), icon: 'Edit2Icon', color: 'primary', text: 'Editar Cuenta' },
        { action: id => this.confirmDeleteAccount(id), icon: 'Trash2Icon', color: 'danger', text: 'Eliminar Cuenta' }
      ]
      this.getAccountData()
    },
    getAccountData(pag) {
      const data = { 
        name: 'getAccountsFlex',
        queryParams: {
          shipper_id: this.$route.params.id,
          delivery_mode: 'meliflex',
          page: pag || this.pagination.page,
          limit: this.pagination.limit
        }
      }
      this.$store.dispatch('fetchService', data)
    },
    confirmDeleteAccount(_id) {
      this.$yesno(this.$t('msg-pregunta-eliminar-cuenta'), () => this.deleteAccount(_id))
    },
    deleteAccount(id) {
      this.loading.account = true
      this.$store.dispatch('fetchService', {
        name: 'deleteAccountFlex',
        params: { account_id: id },
        onSuccess: () => this.successDeleteAccount(id),
        onError: () => {
          this.loading = false
          this.loading.account = false
          this.$newError('¡No pudimos eliminar la cuenta!', 'Inténtalo de nuevo. Si el inconveniente persiste, contacta a nuestro equipo de Support para obtener más información.', 'xlarge')
        }
      })
    },
    successDeleteAccount(id) {
      this.loading.account = false
      this.$newSuccess(
        '¡Cuenta eliminada correctamente!', `La cuenta ${id} ha sido eliminada.`, 'large'
      )
      this.getAccountData()
    },
    openModalEdit(id) {
      this.selectedId = id
      this.$nextTick(() => {
        this.$bvModal.show('modalEditMeliFlex')
      })
    },
    refreshID() {
      this.selectedId = null
    }
  }
}
</script>
<style>
.table-enviaflex .table-render-skeleton {
  overflow-x: hidden !important;
}
</style>